// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__3-wBL","heading":"LearnWin_heading__midZn","subheading":"LearnWin_subheading__Fu5Mm","grid":"LearnWin_grid__UOIl7","card":"LearnWin_card__4FLb-"};